import { post } from '../api/client';
import { QuoteRequest, QuoteResponse, RegOnlyResponse } from '../../models/services/api/postQuote';
import { log } from '@domgen/shared/utils/log';

export const postQuote = async (
  quoteRequest: QuoteRequest,
): Promise<QuoteResponse | RegOnlyResponse> => {
  try {
    return await post<QuoteResponse | RegOnlyResponse>(`/v2/quote`, quoteRequest);
  } catch (err) {
    log.error({ message: 'Fetch error', data: err });
    throw err;
  }
};
